import React, { useState } from 'react';
import '../../Default.css';
import '../../components_ui/accordion/Accordion.css';
import './Readings.css';
import Readings from './readingsType';

const Psalm = ({psalm={shortcut: "", chorus: "", lyrics: [{verse: [""]}]}}) => {
    return (
        <>
            <div className='shortcut'>
                {psalm.shortcut}
            </div>
            {psalm.lyrics.map((elem) => <>
                <div className='psalm-chorus'>
                  Ref. {psalm.chorus}
                </div>
                <div className='psalm-verse'>
                    {elem.verse.map((verse) => 
                        <>{verse}<br/></>)}
                </div>
            </>)}
        </>
    )
};

const Acclamation = ({acclamation={shortcut: "", acclamation: "", text: [""]}}) => {
    return (
        <>
            <div className='shortcut'>
                {acclamation.shortcut}
            </div>
            <div className='psalm-chorus'>
                {acclamation.acclamation}
            </div>
            <div className='psalm-verse'> 
                {acclamation.text.map((verse) => <>
                    {verse}
                </>)}
            </div>
        </>
    )
};

const Reading = ({reading={shortcut: "", book: "", paragraphs: [""]}}) => {
    return (
        <>
            <div className='shortcut'>
                {reading.shortcut}
            </div>
            <div className='book'>
                {reading.book}
            </div>
            <div className='reading-paragraph'> 
                {reading.paragraphs.map((par) => <>
                    <p>{par}</p>
                </>)}
            </div>
        </>
    )
};

function DayRender(item: Readings) {
    const [reading1_isActive, reading1_setIsActive] = useState(false);
    const [psalm_isActive, psalm_setIsActive] = useState(false);
    const [reading2_isActive, reading2_setIsActive] = useState(false);
    const [acclamation_isActive, acclamation_setIsActive] = useState(false);
    const [gospel_isActive, gospel_setIsActive] = useState(false);

    return (
      <>
        <div className="page-title">
          {item.day}
        </div>
        <div>
            <div className="accordion-item">
                <div className="accordion-title" onClick={() => reading1_setIsActive(!reading1_isActive)}>
                    <div>Pierwsze czytanie</div>
                    <div>{reading1_isActive ? '-' : '+'}</div>
                </div>
                {reading1_isActive && <div className="accordion-content"><Reading reading={item.first_reading}/></div>}
            </div>
            <div className="accordion-item">
                <div className="accordion-title" onClick={() => psalm_setIsActive(!psalm_isActive)}>
                    <div>Psalm</div>
                    <div>{psalm_isActive ? '-' : '+'}</div>
                </div>
                {psalm_isActive && <div className="accordion-content"><Psalm psalm={item.psalm}/></div>}
            </div>
            {item.secound_reading &&
                <div className="accordion-item">
                    <div className="accordion-title" onClick={() => reading2_setIsActive(!reading2_isActive)}>
                        <div>Drugie czytanie</div>
                        <div>{reading2_isActive ? '-' : '+'}</div>
                    </div>
                    {reading2_isActive && <div className="accordion-content"><Reading reading={item.secound_reading}/></div>}
                </div>
            }
            <div className="accordion-item">
                <div className="accordion-title" onClick={() => acclamation_setIsActive(!acclamation_isActive)}>
                    <div>Aklamacja</div>
                    <div>{acclamation_isActive ? '-' : '+'}</div>
                </div>
                {acclamation_isActive && <div className="accordion-content"><Acclamation acclamation={item.acclamation}/></div>}
            </div>
            <div className="accordion-item">
                <div className="accordion-title" onClick={() => gospel_setIsActive(!gospel_isActive)}>
                    <div>Ewangelia</div>
                    <div>{gospel_isActive ? '-' : '+'}</div>
                </div>
                {gospel_isActive && <div className="accordion-content"><Reading reading={item.gospel}/></div>}
            </div>
        </div>
      </>
    );
}

export default DayRender;